<template>
  <div data-grm-comp="RoomCBTLogUserResult">
    <table>
      <colgroup>
        <col width="1">
        <col width="2">
        <col width="10">
        <col width="10">
        <col width="2">
        <col width="2">
      </colgroup>
      <thead>
      <tr>
        <th>번호</th>
        <th>유형</th>
        <th>제출 답안</th>
        <th>정답</th>
        <th>결과</th>
        <th>배점</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(question, i) in getCBTLogUserQuestionList(roomCbtUser)" :key="question.questionId">
          <td>{{ i+1 }}</td>
          <td>{{ question.questionType === 'CHOICE' ? '객관식' : '주관식' }}</td>
          <td>
            <div class="flex items-center gap-x-0.5">
              <span v-for="(answer, i) in question.answerList" :key="answer.answerId"
                    class="w-4 h-4 rounded-full text-xs flex justify-center items-center"
                    :class="answer.correct ? 'bg-black' : 'border'"
              >{{ i+1 }}</span>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-x-0.5">
              <span v-for="(answer, i) in cbtLog.cbt.questionList[i]?.answerList" :key="answer.answerId"
                    class="w-4 h-4 rounded-full text-xs flex justify-center items-center"
                    :class="answer.correct ? 'bg-black' : 'border'"
              >{{ i+1 }}</span>
            </div>
          </td>
          <td>{{ question.isCorrect ? 'O' : 'X' }}</td>
          <td>{{ question.questionScore }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'RoomCBTLogUserResult',
  props: {
    roomCbtUser: { type: Object, required: true }
  },
  computed: {
    ...mapState('cbt', [
      'cbtLog',
    ]),
    ...mapGetters('cbt', [
      'getCBTLogUserQuestionList',
    ]),
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  border: 1px solid #ccc;
}
thead {
  tr {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
tbody {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  &:first-child {
    border-top: none;
  }
}
tr {
  height: 40px;
  white-space: nowrap;
}
th {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
td {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
</style>